import {Component, Input, ViewChild} from "@angular/core";
import {FeedbackModalComponent} from "./feedback-modal.component";
import {FeedbackService} from "./feedback.service";
import {FeedbackConfiguration} from "./feedback-configuration.model";


export class FeedbackComponent {

  
  private feedbackModal: FeedbackModalComponent;

  
  configuration: FeedbackConfiguration;

  isHidden = false;
  isLoading = false;
  isScreenshotMode = false;

  constructor(private feedback: FeedbackService) {
    feedback.buttonComponent = this;
  }

  /**
   * Cancel taking of screenshot.
   */
  public cancelScreenshot(): void {
    if (this.configuration.onCancelScreenshot) {
      this.configuration.onCancelScreenshot();
    }

    this.isScreenshotMode = false;

    this.feedbackModal.openModal();
    this.feedback.destroyCanvas();
  }

  /**
   * Clear screenshots.
   */
  public clearScreenshots(): void {
    this.feedback.clearScreenshots();
  }

  /**
   * Get all screenshots taken.
   * @return {string[]} the screenshots as dataUrls.
   */
  public getScreenshots(): string[] {
    return this.feedback.getScreenshots();
  }

  /**
   * Open feedback modal.
   */
  public openFeedbackModal(): void {
    if (this.configuration.onOpen) {
      this.configuration.onOpen();
    }

    this.isHidden = true;
    this.feedbackModal.openModal();
  }

  /**
   * Take a screenshot.
   */
  public takeScreenshot(): void {
    this.feedback.takeScreenshot();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: "ngx-bootstrap-feedback", 
  styles: [`
    @keyframes slide {
          100% { bottom: 0; }
    }
    .send-feedback-button {
        animation: slide 0.3s forwards;
        bottom: -40px;
        right: 56px;
        position: fixed;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        font-size: 12px;
        text-align: center;
        z-index: 9001;
        cursor: pointer;
        color: #fff;
        background-color: #8E979F;
        border: transparent;
    }`],
  template: `<div [attr.class]="configuration.feedbackButtonClass ? configuration.feedbackButtonClass : 'send-feedback-button btn'"
     [ngClass]="{hidden: isHidden}"
     (click)="isScreenshotMode ? null : openFeedbackModal()">
  <!--- SEND FEEDBACK -->
  <div *ngIf="!isScreenshotMode">
    {{configuration.feedbackButtonText ? configuration.feedbackButtonText : "Send Feedback"}}
    <span class="glyphicon glyphicon-comment" aria-hidden="true"></span>
  </div>
  <!--- /SEND FEEDBACK -->
  <!-- SCREENSHOT OPTIONS -->
  <div *ngIf="isScreenshotMode">
    <span>Options</span>
    <div class="row">
      <div class="col-xs-12">
        <button [attr.class]="'btn-feedback ' + (configuration.takeScreenshotButtonClass ? configuration.takeScreenshotButtonClass : 'btn btn-primary btn-block')"
                [attr.disabled]="isLoading ? true : null"
                (click)="takeScreenshot()"
                [ngClass]="{'loading-icon': configuration.enableLoadingIconClass ? isLoading : false}">
          {{configuration.takeScreenshotButtonText ? configuration.takeScreenshotButtonText : "Take Screenshot"}}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <button [attr.class]="'btn-feedback ' + (configuration.cancelScreenshotButtonClass ? configuration.cancelScreenshotButtonClass : 'btn btn-default btn-block')"
                [attr.disabled]="isLoading ? true : null"
                (click)="cancelScreenshot()">
          {{configuration.cancelScreenshotButtonText ? configuration.cancelScreenshotButtonText : "Cancel"}}
        </button>
      </div>
    </div>
  </div>
  <!-- /SCREENSHOT OPTIONS -->
</div>
<ngx-bootstrap-feedback-modal [configuration]="configuration">
  <ng-content></ng-content>
</ngx-bootstrap-feedback-modal>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FeedbackService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'feedbackModal': [{ type: ViewChild, args: [FeedbackModalComponent, ] },],
'configuration': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
